<template>
  <div class="row">
    <div class="col-12">
      <p v-if="$can('create', 'customers', 'without-job-context')" class="text-right">
        <router-link class="btn btn-primary" :to="{ name: 'customers.create' }">
          <font-awesome-icon :icon="['fal', 'plus-circle']" />
          Create
        </router-link>
      </p>

      <advanced-filter
        key="customer-filter"
        :refs="$refs"
        :select-filters="selectFilters"
        :date-range="true"
      ></advanced-filter>

      <v-server-table
        ref="table"
        url="/customers?with=primaryContact;postalAddress"
        :columns="columns"
        :options="options"
      ></v-server-table>
    </div>
  </div>
</template>

<script type="text/babel">
import AdvancedFilter from "../../components/common/AdvancedFilter.vue";

export default {
  components: {
    AdvancedFilter,
  },

  data() {
    return {
      selectFilters: {
        customers: {
          options: [
            {
              label: "Individuals",
              value: "individuals",
            },
            {
              label: "Companies",
              value: "companies",
            },
          ],
        },
        company_type: {
          options: [
            { label: "Real Estate", value: "Real Estate" },
            { label: "Builder", value: "Builder" },
            { label: "Contract", value: "Contract" },
            { label: "Commercial", value: "Commercial" },
            { label: "Retail Business", value: "Retail Business" },
            { label: "Hospitality", value: "Hospitality" },
            { label: "Health", value: "Health" },
          ],
        },
        brand: {
          options: [],
        },
      },

      columns: [
        "name",
        "is_company",
        "primary_contact",
        "postal_address",
        "phone",
        "mobile",
        "email",
      ],
      options: {
        advancedFilter: true,
        sortable: ["name", "primary_contact"],
        requestAdapter: (data) => {
          const result = data;

          if (data.orderBy && data.orderBy === "name") {
            result.orderBy = "";
            result.orderByName = 1;
          }

          if (data.orderBy && data.orderBy === "primary_contact") {
            result.orderBy = "";
            result.orderByPrimaryContact = 1;
          }

          return result;
        },
        templates: {
          name: (h, o) =>
            h("customer-object", {
              props: {
                entityId: o.id,
                name: o.is_company
                  ? o.company_name
                  : this.$lodash.get(o, "primary_contact.name", ""),
              },
            }),
          is_company: (h, o) => (o.is_company ? "Yes" : ""),
          primary_contact: (h, o) => this.$lodash.get(o, "primary_contact.name"),
          phone: (h, o) =>
            h("phone-number", {
              props: {
                number: this.$lodash.get(o, "primary_contact.phone", ""),
              },
            }),
          mobile: (h, o) =>
            h("phone-number", {
              props: {
                number: this.$lodash.get(o, "primary_contact.mobile", ""),
              },
            }),
          email: (h, o) => this.$lodash.get(o, "primary_contact.email"),
          postal_address: (h, o) => this.$lodash.get(o, "postal_address.shortAddress"),
        },
      },
    };
  },

  beforeCreate() {
    this.$store.commit("advanced-filter/resetSelectFilters");
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      if (this.$can("read", "customers", "filter-by-brand")) {
        const brands = await this.$store.dispatch("brands/getData");

        brands.forEach((brand) => {
          this.selectFilters.brand.options = this.selectFilters.brand.options.concat({
            label: brand.name,
            value: brand.id,
          });
        });
      } else {
        delete this.selectFilters.brand;
      }
    },
  },
};
</script>
